<!-- @if (isImage || isPdf) {
<a (click)="openPreview()" [matTooltip]="file_name" role="button">
	<i class="fa main-icon" [ngClass]="'fa-'+getFileExtension()"></i>
</a>
}@else {
<a href="{{File_Storage_URL}}{{removeDomain()}}" target="_blank" [matTooltip]="file_name">
	<i class="fa main-icon" [ngClass]="'fa-'+getFileExtension()"></i>
</a>
} -->
<a href="{{File_Storage_URL}}{{removeDomain()}}" target="_blank" [matTooltip]="file_name">
	<i class="fa main-icon" [ngClass]="'fa-'+getFileExtension()"></i>
</a>
<ng-template #modal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">{{file_name}}</h5>
		<button class="btn-close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body text-center">
		@if (fileUrl && isImage) {
		<img [src]="fileUrl" class="img-preview" />
		}
		@if (fileUrl && isPdf) {
		<pdf-viewer *ngIf="fileUrl && isPdf" [src]="fileUrl" [render-text]="true" [original-size]="true"
			[show-borders]="true" style="width: 100%;"></pdf-viewer>
		}
	</div>
	<div class="modal-footer">
		<button class="btn btn-sm btn-info" (click)="copyLink()">
			Copy File Link
		</button>
		<button class="btn btn-sm btn-secondary" (click)="modal.close()">
			Close
		</button>
	</div>
</ng-template>